import { useEffect } from 'react';
import styled from 'styled-components';

const ScrollToTopButton = () => {
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const button = document.getElementById('scrollToTopButton');
      if (button) {
        if (scrollY > 100) {
          button.style.display = 'flex';
        } else {
          button.style.display = 'none';
        }
      }
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // 페이지 상단으로 스크롤하는 함수
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <ToTopButtonBox id="scrollToTopButton">
      <ToTopButton onClick={scrollToTop}>
        <img
          src="/assets/images/arrow/top-button.svg"
          alt=""
          style={{ width: '48px' }}
        />
      </ToTopButton>
    </ToTopButtonBox>
  );
};

export default ScrollToTopButton;

const ToTopButtonBox = styled.div`
  width: 100%;
  max-width: 900px; /* Container와 동일한 너비 */
  position: fixed;
  left: 50%; /* 화면의 정중앙 기준 */
  bottom: 80px;
  cursor: pointer;
  z-index: 997;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 0 16px;
  margin: 0 auto;
  transform: translateX(-50%); /* 왼쪽으로 자기 너비의 50%만큼 이동 */
  pointer-events: none;
`;
const ToTopButton = styled.div`
  cursor: pointer;
  pointer-events: auto;
`;
